import { Component, OnInit } from '@angular/core';

import { ApiInfoService } from 'app/services';

@Component({
  selector: 'app-env-info',
  templateUrl: './env-info.component.html',
  styleUrls: ['./env-info.component.scss'],
})
export class EnvInfoComponent implements OnInit {
  infoDataApi!: any;

  constructor(private readonly apiInfoService: ApiInfoService) {}

  ngOnInit() {
    this.apiInfoService.findApiInfo().subscribe((response) => {
      this.infoDataApi = response;
    });
  }

  getEnv(): any {
    return this.infoDataApi['dcs-info'].activeProfiles;
  }


}
